import type { EntityValidationRules } from "../services/validationService";

export default class DistributorStorno {
  file?: File;
  cancellationRecordId: string;
  distributorId: string;
}

export const DistributorStornoValidationRules: EntityValidationRules<DistributorStorno> = {
  file: {
    required: "fileRequired",
    isFileType: {
      type: ["text/csv", "application/vnd.ms-excel", ""], // On Windows is recognized as application/vnd.ms-excel and without Office mime type is empty string %)
      customMessage: "csv",
    },
  },
  cancellationRecordId: {
    required: true,
    isLength: {
      min: 3,
      max: 50,
    },
  },
  distributorId: {
    required: true,
  },
};
